import { render, staticRenderFns } from "./mineExchangesixth.vue?vue&type=template&id=381a25f0&scoped=true"
import script from "./mineExchangesixth.vue?vue&type=script&lang=js"
export * from "./mineExchangesixth.vue?vue&type=script&lang=js"
import style0 from "./mineExchangesixth.vue?vue&type=style&index=0&id=381a25f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381a25f0",
  null
  
)

export default component.exports